import React from "react";

import AlertBanner from "components/templates/banner/AlertBanner";

export const CONNECTION_ALERT_BANNER_HEIGHT = 48;

const NETWORK_DISCONNECTED_MESSAGE = "네트워크 연결이 끊겼습니다. 인터넷 연결 상태를 확인해주세요.";
const WEBSOCKET_DISCONNECTED_MESSAGE = "실시간 연결이 끊겼습니다. 페이지를 새로고침하거나 잠시 후 다시 시도해주세요.";

function ConnectionAlertBanner({ showNetworkDisconnected, showWebSocketDisconnected }) {
    if (showNetworkDisconnected) {
        return <AlertBanner alertMessage={NETWORK_DISCONNECTED_MESSAGE} />;
    }

    if (showWebSocketDisconnected) {
        return <AlertBanner alertMessage={WEBSOCKET_DISCONNECTED_MESSAGE} />;
    }

    return null;
}

export default ConnectionAlertBanner;
